// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1Uvmk","author":"Table_author__2gPWz","authorImage":"Table_authorImage__2Gbls","unreadRow":"Table_unreadRow__1z4Rs"};